import React from 'react';

export type IsometricMediaSize =
  | 'xtiny'
  | 'tiny'
  | 'small'
  | 'medium'
  | 'large'
  | 'xlarge';

export type IsometricMediaCategoryType = {
  Insurances:
    | 'AssistanceCancellation'
    | 'FlightCancellation'
    | 'Liability'
    | 'NoInsurance';
  Places: 'Location-No' | 'Globe';
  TravelProducts: 'Hotel';
  Alerts: 'Error';
  Seats:
    | 'Seat-Side'
    | 'Seat-Together'
    | 'Seat-Checked'
    | 'Seat-Empty'
    | 'Seat-Fail'
    | 'Seat-Window'
    | 'Seat-Middle';
  Baggage:
    | 'Baggage-Small'
    | 'Baggage-Measure'
    | 'Baggage-Fail'
    | 'Baggage-Oversized'
    | 'Baggage-Extend'
    | 'Baggage-Check-In'
    | 'Baggage-Medium'
    | 'Baggage-Small-Big'
    | 'Baggage-Success';
  Miscellaneous: 'Baby-Carriage';
  Payments: 'Wallet';
};

export type IsometricMediaCategory = keyof IsometricMediaCategoryType;

export interface IsometricMediaProps<
  Category extends keyof IsometricMediaCategoryType,
  Name extends IsometricMediaCategoryType[Category]
> {
  size: IsometricMediaSize;
  category: Category;
  name: Name;
  alt?: string;
}

const isometricMediaSizes: Record<IsometricMediaSize, number> = {
  xtiny: 48,
  tiny: 64,
  small: 80,
  medium: 96,
  large: 128,
  xlarge: 160,
};

export const IsometricMedia = React.forwardRef(
  <
    Category extends keyof IsometricMediaCategoryType,
    Name extends IsometricMediaCategoryType[Category]
  >(
    { size, category, name, alt = '' }: IsometricMediaProps<Category, Name>,
    ref: React.ForwardedRef<HTMLImageElement>
  ) => (
    <img
      src={`/images/onefront/branded/Isometric${category}/${name}.svg`}
      alt={alt}
      width={isometricMediaSizes[size]}
      height={isometricMediaSizes[size]}
      ref={ref}
    />
  )
);
